export const signInProcessIdParam = "sipid";
export const signInProcessSecretParam = "sips";
